import Resource from '../../../api/resources/Resource'

class PatientServices extends Resource {
    // TODO: Mover al servicio generico de pacientes
    async mergePatients(targetPatientId, sourcePatientId) {
        const response = await this.axios.put(`/patients/${targetPatientId}/merge`, null, { params: { sourcePatientId } })
        return response.data
    }
}

export default new PatientServices()
